





















import CookiePolicyModalWrapper
  from '@/components/cookie-consent/wrappers/CookiePolicyModalWrapper.vue'
import CookieConsentSettingsModalWrapper
  from '@/components/cookie-consent/wrappers/CookieConsentSettingsModalWrapper.vue'
import CookieConsentMainModalWrapper
  from '@/components/cookie-consent/wrappers/CookieConsentMainModalWrapper.vue'
import ModalV2 from '@/components/common/ModalV2.vue'
import AnslSpinner from '@/components/LoadingSpinner.vue'

import {
  defineComponent,
  computed,
  onMounted,
  watch
} from '@vue/composition-api'
import {
  getPolicyModalOpen,
  getConsentModalOpen,
  getMainModalOpen,
  preloadCookies
} from '@/store/modules/cookie-consent.store'
import { CfAnslCookieConsent } from '@/types/ansl-space/types/cf-ansl-cookie-consent'
import { Entry } from 'contentful'

import { accessorFactory, Namespace } from '@/store'

const {
  fetchContent,
  getLoading,
  getException,
  getContent
} = accessorFactory<Entry<CfAnslCookieConsent>>(Namespace.CookieConsentContent)

export default defineComponent({
  components: {
    CookieConsentSettingsModalWrapper,
    CookieConsentMainModalWrapper,
    CookiePolicyModalWrapper,
    ModalV2,
    AnslSpinner
  },
  setup (props, { root }) {
    const store = root.$store

    fetchContent(store)

    const loading = computed(() => getLoading(store))
    const exception = computed(() => getException(store))

    const content = computed(() => getContent(store))

    const isMainModalOpen = computed(() => getMainModalOpen(store))
    const isPolicyModalOpen = computed(() => getPolicyModalOpen(store))
    const isConsentModalOpen = computed(() => getConsentModalOpen(store))

    const isAnyModalOpen = computed(() => isMainModalOpen.value || isPolicyModalOpen.value || isConsentModalOpen.value)

    watch(isAnyModalOpen, val => {
      if (val) {
        document.body.classList.add('disable-scroll')
      } else {
        document.body.classList.remove('disable-scroll')
      }
    })

    onMounted(() => {
      preloadCookies(store)
    })

    return {
      loading,
      exception,
      content,
      isMainModalOpen,
      isConsentModalOpen,
      isPolicyModalOpen,
      isAnyModalOpen
    }
  }
})
